"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PriceTypes;
(function (PriceTypes) {
    PriceTypes["NET_PRICE"] = "NetPrice";
    PriceTypes["FINAL_PRICE"] = "FinalPrice";
    PriceTypes["MONEY"] = "Money";
})(PriceTypes = exports.PriceTypes || (exports.PriceTypes = {}));
